import reducer, { KansatsuKirokuState } from "./reducers";
import * as kansatsuKirokuOperations from "./operations";
export {
  kansatsuKirokuOperations,
  KansatsuKirokuState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKiroku/index.ts